// TODO: Remove or refactor — alpha user payments now handled via SMS payment link on landing page (/member-subscribe)
import Image from "next/image";
import { useRouter } from "next/navigation";
import { FC, useEffect } from "react";

import { CommonFooter, CommonHeader } from "@/features/common";
import WelcomeImageSrc from "@/imgs/welcome_screen.png";
import { Button, Typography } from "@/shared/ui";

import { Footer } from "../footer";
import { MediaQuery } from "../media-query";

import styles from "./subscription-screen.module.scss";

const SubscriptionScreen: FC = ({}) => {
  const { push, prefetch } = useRouter();

  useEffect(() => {
    prefetch("/platform/profile");
    prefetch("/platform/subscription-plans");
  }, []);

  return (
    <div className={styles.subscriptionScreen}>
      <CommonHeader />

      <div className={styles.content}>
        <div className={styles.imageWrapper}>
          <Image src={WelcomeImageSrc} className={styles.welcomeImage} alt="welcome-image" />
        </div>
        <main className={styles.container}>
          <div className={styles.top}>
            <Typography bold as="h1" variant="large-title" align="center">
              Welcome to Sociètè
            </Typography>
            <Typography as="h2" variant="footnote" align="center" className={styles.description}>
              Access to Societe requires an active subscription.
            </Typography>
          </div>

          <div className={styles.bottom}>
            <Button size="big" onClick={() => push("/platform/subscription-plans")}>
              Subscribe Now
            </Button>
          </div>
        </main>
      </div>

      <CommonFooter />
      <MediaQuery.Laptop>
        <Footer fixedAtBottom transparent />
      </MediaQuery.Laptop>
    </div>
  );
};

export { SubscriptionScreen };
